import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import VirtualizedListView, {ROW_HEIGHT} from 'shared/components/VirtualizedListView/VirtualizedListView';
import {getResizeUrl} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import ChildrenFader from 'shared/components/ChildrenFader';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Restore from 'material-ui/svg-icons/av/replay';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import EyeIcon from 'material-ui/svg-icons/image/remove-red-eye';
import * as routes from 'App/routeConstants';
import ImageDropDownMenu from './ImageDropDownMenu';
import {
  CONTENT_PADDING_TOP,
  CONTENT_PADDING_LEFT,
  CONTENT_PADDING_RIGHT,
  TRASH_FOLDER,
  DELETE_IMAGE_DIALOG,
} from '../consts';
import { PANELS } from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import { openDialog } from '../helpers';
import TooltipWrapper from 'shared/components/TooltipWrapper';

const tableStyles = require('shared/components/TableHelpers/TableStyles.scss');
const IMAGE_SIZE = 50;
const styles = {
  column: {
    marginLeft: 55,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minWidth: 0,
    width: 0,
  },
  tooltipStyle: {
    maxWidth: 'auto',
    padding: '0 8px',
    fontSize: '10px',
    lineHeight: '22px',
  },
};

export default class ListView extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      imageDropDownMenu: null,
    };
  }

  toggleImageDropDownMenu = (value, id) => {
    const imageDropDownMenu = value ? id : null;
    this.setState({ imageDropDownMenu });
  };

  restoreFromTrash = (item) => {
    this.props.setWindowBusy(true);
    const currentFolder = _.replace(this.props.currentFolder, /\\/gi, '/');
    const files = [{
      options: 'autorename',
      name: item.name,
      type: 'Images',
      folder: currentFolder ? `/${currentFolder}/` : '/',
    }];
    this.context.imageUtils.doRestoreFromTrash({
      files,
    }, (data) => {
      this.props.setWindowBusy(false);
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        this.setState({ error: response.error.message });
      }
    });
  };

  openDeleteImageDialog = (item) => {
    const { integrated, openLazyPanel } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.DELETE_IMAGE, null, null, { images: item.id });
    } else {
      openDialog({
        dialogName: DELETE_IMAGE_DIALOG,
        images: [item.id],
      });
    }
  };

  columns = [
    {
      property: 'url',
      props: {
        style: {
          marginLeft: 24,
          width: IMAGE_SIZE,
        },
      },
      header: {
        label: '',
      },
      cell: {
        formatters: [value => {
          return (
            <div
              style={{backgroundImage: `url(${getResizeUrl(value, {width: IMAGE_SIZE * 2})})`}}
              className={tableStyles.thumbImg}
            />
          );
        }],
      }
    },
    {
      property: 'name',
      props: {
        style: {
          ...styles.column,
          flexGrow: 3,
          flexShrink: 2,
          whiteSpace: 'nowrap',
        }
      },
      header: {
        label: 'Image name',
      },
      cell: {
        formatters: [name => <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%',
        }}>{name}</div>],
      },
    },
    {
      property: 'size',
      props: {
        style: {
          ...styles.column,
          flexGrow: 2,
          flexShrink: 1,
        },
      },
      header: {
        label: 'Image size',
      },
      cell: {
        formatters: [size => <div>{size}kb</div>],
      }
    },
    {
      property: 'data',
      props: {
        style: {
          ...styles.column,
          flexGrow: 5,
          flexShrink: 1,
        },
      },
      header: {
        label: 'Date',
      },
      cell: {
        formatters: [(value, data, hovered) => {
          const { currentFolder, resourceType, integrated } = this.props;
          const { imageDropDownMenu } = this.state;
          let date = data.rowData.date;
          const year = date.slice(0, 4);
          const month = date.slice(4, 6);
          const day = date.slice(6, 8);
          date = `${month}/${day}/${year}`;
          return (
            <div style={{display: 'flex', width: '100%', height: '100%'}}>
              <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'space-between', alignItems: 'center', paddingRight: 30}}>
                <div>{date}</div>
                <ChildrenFader
                  onClick = {e => e.stopPropagation()}
                  visible = {hovered || imageDropDownMenu === data.rowData.id}
                  transitionDurationMs={75}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  { resourceType !== 'Icons' && currentFolder === TRASH_FOLDER
                    ? <TooltipWrapper
                        tooltip="Restore from Trash"
                        popoverType="grey"
                        anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
                        targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
                        tooltipStyle={styles.tooltipStyle}
                      >
                        <IconButton
                          style={styles.imageButton}
                          iconStyle={styles.imageButtonIcon}
                          onClick={this.restoreFromTrash.bind(this, data.rowData)}
                        >
                          <Restore />
                        </IconButton>
                      </TooltipWrapper>
                    : <ImageDropDownMenu
                        item={data.rowData}
                        tooltipPosition="top-center"
                        currentFolder={currentFolder}
                        resourceType={resourceType}
                        innerkey={data.rowData.id}
                        integrated={integrated}
                        toggleImageDropDownMenu={this.toggleImageDropDownMenu}
                      />
                  }
                  { resourceType !== 'Icons' && currentFolder === TRASH_FOLDER
                    ? <TooltipWrapper
                        tooltip="Delete"
                        popoverType="grey"
                        anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
                        targetOrigin={{horizontal: 'middle', vertical: 'bottom'}}
                        tooltipStyle={styles.tooltipStyle}
                      >
                        <IconButton
                          style={styles.imageButton}
                          iconStyle={styles.imageButtonIcon}
                          onClick={this.openDeleteImageDialog.bind(this, data.rowData)}
                        >
                          <DeleteIcon/>
                        </IconButton>
                      </TooltipWrapper>
                    : undefined
                    // <RaisedButton
                    // label = "CROP & EDIT"
                    // style={{whiteSpace: 'nowrap'}}
                    // onClick={() => openFeatherEditor({url: data.rowData.url, name: data.rowData.name, path: data.rowData.path})}
                    // />
                  }
                </ChildrenFader>
              </div>
            </div>
          );
        }]
      },
    },
  ];

  render() {
    const { items, currentFolder, ...other} = this.props;
    return (<VirtualizedListView
      key = {currentFolder}
      filterFields = {[]}
      sortFields={[]}
      columns = {this.columns}
      items = {items}
      rowHeight={60}
      headerHeight={CONTENT_PADDING_TOP}
      containerStyle={{
        paddingTop: CONTENT_PADDING_TOP,
        paddingLeft: CONTENT_PADDING_LEFT,
        paddingRight: CONTENT_PADDING_RIGHT,
        marginBottom: 30,
      }}
      headerStyle={{
        left: 0,
        right: 0,
        paddingLeft: CONTENT_PADDING_LEFT,
        paddingRight: CONTENT_PADDING_RIGHT,
      }}
      {...other}
    />);
  }
}